import React from "react";
import { RxCaretLeft, RxCaretRight } from "react-icons/rx";

export default function PCRightContent({
  mainColor,
  activeStepPC,
  setActiveStepPC,
  activeStepTitlePC,
  setActiveStepTitlePC,
  preConsultationSteps,
  renderStepContentRightPC,
  handleNextStepPC,
  handlePrevStepPC,
}) {
  return (
    <div className="inner-content">
      <div className="bf-header">
        <RxCaretLeft
          onClick={handlePrevStepPC}
          style={{
            cursor: activeStepPC > 0 ? "pointer" : "not-allowed",
            color: activeStepPC > 0 ? "inherit" : "lightgray",
          }}
        />
        {activeStepTitlePC && (
          <p className="section-title">{activeStepTitlePC}</p>
        )}
        <RxCaretRight
          onClick={handleNextStepPC}
          style={{
            cursor:
              activeStepPC < preConsultationSteps.length - 1
                ? "pointer"
                : "not-allowed",
            color:
              activeStepPC < preConsultationSteps.length - 1
                ? "inherit"
                : "lightgray",
          }}
        />
      </div>
      <div className="steps-container">
        {preConsultationSteps?.map((step, index) => (
          <div
            key={`${step.type}-${step.countryName}-${index}`}
            className={`step-bar ${step.type !== "about-trip" ? "short" : ""}`}
            onClick={() => {
              setActiveStepPC(index);
              setActiveStepTitlePC(
                `${step.title}${
                  step.countryName ? ` - ${step.countryName}` : ""
                }`
              );
            }}
            style={{
              backgroundColor: index <= activeStepPC ? mainColor : "lightgray",
              transition: "background-color 0.3s ease",
            }}
          ></div>
        ))}
      </div>
      <div className="step-content">{renderStepContentRightPC()}</div>
    </div>
  );
}
